
import { filterObjectKeys } from "@common/ObjectsHelper";
import { Vue, Component, Prop } from "vue-property-decorator";
import { TableClasses, TableSettings } from "./types";

@Component
export default class BaseJConfTable extends Vue {
    @Prop() tableSettings: TableSettings;
    @Prop({ default: () => { return {} } }) classes: TableClasses;

    readonly SLOT_NAMES = ['after', 'header'];

    get baseClass() {
        return 'j-conf-table'
    }

    get columns() {
        return filterObjectKeys(this.$scopedSlots, this.SLOT_NAMES, true)
    }

    get rowComputedStyle() {
        return {
            minHeight: typeof this.tableSettings.minRowHeight === "number" ? `${this.tableSettings.minRowHeight}px` : this.tableSettings.minRowHeight
        }
    }
}

